/* Pfeilsteuerung fuer horizontale Produktreihen (.mf-reihe).
   Die Reihen sind CSS-Scrollcontainer. Auf Touchgeraeten wird gewischt,
   mit Maus und Tastatur fehlte bisher jede Bedienung. Dieses Skript
   ergaenzt zwei Schaltflaechen unter jeder Reihe, die ueberlaeuft. */
(function () {
  if (window.__mfReiheNav) return;
  window.__mfReiheNav = true;

  var PFEIL_ZURUECK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>';
  var PFEIL_VOR     = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>';

  function knopf(klasse, beschriftung, inhalt) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mf-reihe-nav__knopf ' + klasse;
    b.setAttribute('aria-label', beschriftung);
    b.innerHTML = inhalt;
    return b;
  }

  function ausstatten(reihe) {
    if (reihe.dataset.mfNav === 'an') return;
    reihe.dataset.mfNav = 'an';

    var nav = document.createElement('div');
    nav.className = 'mf-reihe-nav';

    var zurueck = knopf('mf-reihe-nav__knopf--zurueck', 'Vorherige Produkte anzeigen', PFEIL_ZURUECK);
    var vor     = knopf('mf-reihe-nav__knopf--vor', 'Weitere Produkte anzeigen', PFEIL_VOR);
    nav.appendChild(zurueck);
    nav.appendChild(vor);
    reihe.insertAdjacentElement('afterend', nav);

    function schrittweite() {
      var karte = reihe.firstElementChild;
      if (!karte) return Math.round(reihe.clientWidth * 0.8);
      var stil = window.getComputedStyle(reihe);
      var abstand = parseFloat(stil.columnGap || stil.gap || '16') || 16;
      var kartenbreite = karte.getBoundingClientRect().width + abstand;
      var proSeite = Math.max(1, Math.floor(reihe.clientWidth / kartenbreite));
      return Math.round(kartenbreite * proSeite);
    }

    function blaettern(richtung) {
      var sanft = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      reihe.scrollBy({ left: richtung * schrittweite(), behavior: sanft });
    }

    zurueck.addEventListener('click', function () { blaettern(-1); });
    vor.addEventListener('click', function () { blaettern(1); });

    function stand() {
      var rest = reihe.scrollWidth - reihe.clientWidth;
      nav.classList.toggle('mf-reihe-nav--sichtbar', rest > 4);
      zurueck.disabled = reihe.scrollLeft <= 2;
      vor.disabled = reihe.scrollLeft >= rest - 2;
    }

    reihe.addEventListener('scroll', stand, { passive: true });
    window.addEventListener('resize', stand);
    if ('ResizeObserver' in window) {
      try { new ResizeObserver(stand).observe(reihe); } catch (e) {}
    }
    stand();
    /* Produktbilder laden nach und veraendern die Breite der Reihe. */
    setTimeout(stand, 600);
    setTimeout(stand, 2500);
  }

  function start() {
    var reihen = document.querySelectorAll('.mf-reihe');
    for (var i = 0; i < reihen.length; i++) ausstatten(reihen[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  /* Im Theme-Editor werden Sektionen neu geladen. */
  document.addEventListener('shopify:section:load', start);
})();
